export default __webpack_public_path__ + "static/media/python.a3234e7b.svg";